<template>
    <el-popover
        placement="top"
        width="300"
        trigger="click"
    >
        <h4 class="style-title">{{ title }}</h4>
        <table class="style-container">
            <tr>
                <td width="35%">Font Style</td>
                <td><form-select size="mini" :options="fontStyleOpts" :input-value.sync="textStyle.fontStyle" /></td>
            </tr>
            <tr>
                <td>Font Weight</td>
                <td><form-select size="mini" :options="fontWeightOpts" :input-value.sync="textStyle.fontWeight" /></td>
            </tr>
            <tr>
                <td>Font Family</td>
                <td><form-select size="mini" :options="fontFamilyOpts" :input-value.sync="textStyle.fontFamily" /></td>
            </tr>
            <tr>
                <td>Font Size</td>
                <td><form-input-float size="mini" :input-value.sync="textStyle.fontSize" /></td>
            </tr>
            <tr>
                <td>Line Height</td>
                <td><form-input-float size="mini" :input-value.sync="textStyle.lineHeight" /></td>
            </tr>
            <tr>
                <td>Color</td>
                <td><form-input-float size="mini" :input-value.sync="textStyle.color" /></td>
            </tr>
        </table>
        
        <span slot="reference" class="el-dropdown-link round-btn round-btn-sm">
            <i class="el-icon-more" />
        </span>
    </el-popover>
</template>

<script>
import FormInputFloat from "./FormInputFloat";
import FormSelect from "./FormSelect";
import { FONT_STYLE_OPTS, FONT_WEIGHT_OPTS, FONT_FAMILY_OPTS } from "@/json/font_style_options";

export default {
    components: {
        "form-input-float": FormInputFloat,
        "form-select": FormSelect,
    },
    props: {
        title: {
            type: String
        },
        textStyle: {
            type: Object
        }
    },
    data() {
        return {
            font: {
                fontStyle: "normal",
                fontWeight: "normal",
                fontFamily: "sans-serif",
            },
            fontStyleOpts: FONT_STYLE_OPTS,
            fontWeightOpts: FONT_WEIGHT_OPTS,
            fontFamilyOpts: FONT_FAMILY_OPTS,
        };
    },
    mounted() {
        console.log("this.FONT_FAMILY_OPTS", FONT_FAMILY_OPTS);
    }
};
</script>

<style scoped>
.style-container {
    border-spacing: 0 4px;
}
.style-container tr {
    font-size: 12px;
}
.style-title {
    border-bottom: 1px solid var(--seperation-line-grey);
    padding-bottom: var(--space-2);
    margin-bottom: var(--space-4);
}
</style>


// WEBPACK FOOTER //
// src/components/Form/StyleField.vue